import React, {useState} from 'react'
import DragGroupCollapseBar from './DragGroupCollapseBar'
import DropZone from './DropZone'
import {onDragStart} from './DragContainer'

const DragGroup = (props) => {
    const isGoupManagement = props.dataIndexes[0] === -1

    const [expanded, setExpanded] = useState(isGoupManagement || props.status === 'expanded')
    const elementOrderInGroup = props.dataIndexes[props.dataIndexes.length - 1]

    return <div
        data-element-level={props.dataIndexes.length - 1}
        data-element-index={elementOrderInGroup}
        className={`dragGroup ${props.isHistoryDate ? 'disabled' : ''} ${expanded ? 'expanded' : 'collapsed'}`}
        onDragStart={onDragStart}
    >
        {!isGoupManagement && <DragGroupCollapseBar {...props}
            disabled={props.lastDropzoneIndex === 0}
            expanded={expanded}
            setExpanded={setExpanded}
            groupIndex={elementOrderInGroup}
            toggleGroupCollapseStatus={props.toggleGroupCollapseStatus}
        />}

        <div className={`dragItems ${expanded ? 'expanded' : 'collapsed'}`}>
            {props.children}

            <DropZone
                elementOrderInGroup={props.lastDropzoneIndex}
                reorderGroups={props.reorderGroups}
            />
        </div>
    </div>
}

export default DragGroup